import React, { useEffect } from "react";
import img1 from "../../../assets/gps/call_us.png";
import callLogo from "../../../assets/gps/call_logo.svg";
import { MdPhoneInTalk } from "react-icons/md";
import AOS from "aos";
import "aos/dist/aos.css";
const CallUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);
  return (
    <div
      className="bg-cover bg-center rounded-xl flex mx-4 md:mx-8 lg:mx-12 sm:justify-center sm:flex-row flex-col sm:items-center"
      style={{ backgroundImage: `url(${img1})` }}
      data-aos="zoom-in"
    >
      {/* <img src={Banner} alt="" className='xl:px-14 pt-12 lg:px-12 md:px-12 px-2'/> */}
      <div>
        <h1 className="xl:text-5xl lg:text-3xl text-xl tracking-wide text-white font-bold px-4 lg:px-12 py-4 md:py-12 lg:py-16 sm:text-start text-center">
          Call Us Now -
        </h1>
      </div>
      <div className="flex gap-3 sm:px-0 px-3 sm:gap-5 sm:justify-start justify-center sm:pb-0 pb-3 items-center">
        <div className="flex border border-[#F26422] border-1 rounded-full py-0 items-center gap-0 md:gap-4">
          <MdPhoneInTalk className="text-[#214293] text-4xl xl:text-7xl lg:text-5xl bg-[#F26422] sm:p-3 p-2 rounded-full" />
          <h2 className="text-white md:font-bold text-sm md:text-xl lg:text-2xl xl:text-3xl pr-2 lg:pr-4 xl:pr-12">
            +91 9124578108
          </h2>
        </div>
        <div className="flex border border-[#F26422] border-1 rounded-full py-0 items-center gap-0 md:gap-4">
          <MdPhoneInTalk className="text-[#214293] text-4xl xl:text-7xl lg:text-5xl bg-[#F26422] sm:p-3 p-2 rounded-full" />
          <h2 className="text-white md:font-bold text-sm md:text-xl lg:text-2xl xl:text-3xl pr-2 lg:pr-4 xl:pr-12">
            +91 9124578108
          </h2>
        </div>
      </div>
    </div>
  );
};

export default CallUs;
